import React, { useState, useEffect } from "react";
import { Modal, Dropdown } from "react-bootstrap";
import { FaPlus, FaEllipsisV } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { productAction } from "../../_actions/product.action";
import toast from '../shared/Toast';
import "./product.css";

const BrandPopup = ({ show, onHide, animate }) => {
  const dispatch = useDispatch();
  const [brands, setBrands] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredBrands, setFilteredBrands] = useState([]);
  // We'll use the existing Add Brand popup from Product.js
  // We'll use the existing Edit Brand popup from Product.js
  const [showDeleteBrandModal, setShowDeleteBrandModal] = useState(false);
  // We'll use the existing Delete Brand popup from Product.js
  const [newBrandName, setNewBrandName] = useState("");
  const [selectedBrand, setSelectedBrand] = useState(null);

  // Fetch brands on component mount
  useEffect(() => {
    if (show) {
      fetchBrands();
    }
  }, [show]);

  // Filter brands based on search query
  useEffect(() => {
    if (brands.length > 0) {
      const filtered = brands.filter(brand =>
        brand.brandName.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredBrands(filtered);
    }
  }, [searchQuery, brands]);

  // Fetch brands from API
  const fetchBrands = () => {
    setIsLoading(true);
    dispatch(productAction.listProductBrands())
      .then((response) => {
        console.log("Brands API response:", response);
        if (response?.data?.responseData?.result) {
          setBrands(response.data.responseData.result);
          setFilteredBrands(response.data.responseData.result);
        } else if (response?.data?.responseData?.brands) {
          // Alternative response structure
          setBrands(response.data.responseData.brands);
          setFilteredBrands(response.data.responseData.brands);
        } else {
          setBrands([]);
          setFilteredBrands([]);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching brands:", err);
        setIsLoading(false);
        toast.error("Failed to fetch brands");
      });
  };

  // Handle search input change
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  // Open add brand modal - this will be handled by the parent component
  const handleAddBrandClick = (e) => {
    // Close the brands popup and let the parent component show the add brand popup
    // Pass the event to the parent component
    onHide(e);
  };

  // Open edit brand modal - this will be handled by the parent component
  const handleEditBrandClick = (brand, e) => {
    // Pass the brand to the parent component
    setSelectedBrand(brand);
    // Close the brands popup and let the parent component show the edit brand popup
    onHide({
      target: {
        innerText: "Edit Brand",
        brandData: brand
      }
    });
  };

  // Open delete brand modal - this will be handled by the parent component
  const handleDeleteBrandClick = (brand) => {
    // Pass the brand to the parent component
    setSelectedBrand(brand);
    // Close the brands popup and let the parent component show the delete brand popup
    onHide({
      target: {
        innerText: "Delete Brand",
        brandData: brand
      }
    });
  };

  // Add new brand is handled by the parent component

  // Edit brand is handled by the parent component

  // Delete brand is handled by the parent component

  return (
    <>
      {/* Main Brands Popup */}
      <Modal
        show={show}
        onHide={onHide}
        centered
        backdropClassName="_light_bg"
      >
        <Modal.Body className="p-0">
          <div className="my-brands-modal">
            <h4>My Brands</h4>
            
            {/* Search for brand */}
            <div className="search-input-container">
              <div className="search-icon">
                <i className="fa fa-search"></i>
              </div>
              <input
                type="text"
                className="form-control"
                placeholder="Search for brand"
                value={searchQuery}
                onChange={handleSearchChange}
              />
            </div>

            {/* Brands List */}
            <div className="brands-list-wrapper">
              {isLoading ? (
                <div className="text-center py-4">Loading...</div>
              ) : filteredBrands.length === 0 ? (
                <div className="text-center py-4">
                  {searchQuery ? "No brands found matching your search" : "No brands found"}
                </div>
              ) : (
                filteredBrands.map((brand) => (
                  <div key={brand.brandId || brand._id} className="brand-row">
                    <div className="brand-details">
                      <div className="brand-name">{brand.brandName}</div>
                      <div className="product-count">{brand.productCount || 0} Products</div>
                    </div>
                    <div className="brand-options">
                      <Dropdown>
                        <Dropdown.Toggle variant="link" id={`dropdown-${brand.brandId || brand._id}`} className="dropdown-toggle-no-caret">
                          <FaEllipsisV />
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="dropdown-menu-right">
                          <div className="p-0">
                            <div className="dropdown-item" onClick={() => handleEditBrandClick(brand)}>Edit Brand</div>
                            <div className="dropdown-item text-danger" onClick={() => handleDeleteBrandClick(brand)}>Delete Brand</div>
                          </div>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </div>
                ))
              )}
            </div>

            {/* Bottom action buttons container */}
            <div className="modal-actions-container">
              {/* Add Brand Button - Left aligned */}
              <div className="add-brand-wrapper">
                <div className="add-brand-container" onClick={handleAddBrandClick}>
                  <button
                    className="circular-add-button"
                  >
                    <FaPlus />
                  </button>
                  <span className="add-brand-text">Add Brand</span>
                </div>
              </div>

              {/* Cancel Button - Right aligned */}
              <div className="cancel-wrapper">
                <button
                  className="modal-cancel-button"
                  onClick={onHide}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* We're using the existing Add Brand and Edit Brand popups from Product.js */}

      {/* We're using the existing Delete Brand popup from Product.js */}
    </>
  );
};

export default BrandPopup;